import React, { forwardRef } from "react";
import "./DragOverlayItemStyles.scss";

export const DragOverlayItem = forwardRef(({ id, ...props }, ref) => {
  // console.log("props", id);
  return (
    <div {...props} ref={ref}>
      {/* {id?.bannerTitle} */}
    </div>
  );
});
